<h3 class="text-lg ml-2 mr-2">Lagerartikel auswählen</h3>
<p class="color-light ml-2 mr-2">Bitte wählen Sie den gewünschten Lagerartikel durch tippen aus.</p>

@if (loading$ | async) {
  <div class="flex flex-row justify-center pt-2 pb-2 min-h">
    <soft-loading-spinner class="spin"></soft-loading-spinner>
  </div>
} @else {
  <div class="flex flex-col ml-2 mr-2 border-box mt-2">
    @if (lagerartikel$ | async; as lagerartikel) {
      <div class="flex flex-col flex-nowrap mb-3 mt-3 soft-scroll-vertical border-box" style="overflow: auto; max-height: 45vh;">
        @for (lagerartikel of lagerartikel; track lagerartikel; let last = $last) {
          <div class="flex flex-col py-2" [ngClass]="last ? '' : 'border-b-separator'" style="width: 100%; padding: 0.5rem 0;" (click)="select(lagerartikel)">
            <span class="text-sm color-light">{{ lagerartikel?.artikelnummer }}</span>
            <span style="font-weight: 600;">{{ lagerartikel?.bezeichnung }}</span>
          </div>
        }
      </div>
    }
  </div>
}


<button class="soft-button secondary custom mt-3" (click)="close(null)">Abbrechen</button>
